export default "__VITE_ASSET__CGFVKlh1__"